import { useMutation, useQueryClient } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useUpdateSkillDimensionChildren = () => {
  const queryClient = useQueryClient();
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useMutation({
    mutationFn: async ({ dimensionId, children }) => {
      const result = await restClient({
        url: `${prefix}/skill-dimension/${dimensionId}/children`,
        method: 'PUT',
        data: children
      });
      return result;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['skillDimensions']);
    }
  });
};
